import React from 'react';
import {
  Box,
  Heading,
  Grid,
  GridItem,
  useBreakpointValue
} from '@chakra-ui/react';
import { Market, MarketOutcome } from '../../types/marketTypes';
import { Event } from '../../types/types';
import { DexchMarketContent } from './DexchMarketContent';

interface DexchMarketSectionProps {
  title: string;
  markets: Market[];
  event?: Event;
  compact?: boolean;
  gridColumns?: string;
}

export const DexchMarketSection: React.FC<DexchMarketSectionProps> = ({
  title,
  markets,
  event,
  compact = false,
  gridColumns = "repeat(auto-fill, minmax(300px, 1fr))"
}) => {
  // Responsive values
  const headingSize = useBreakpointValue({ base: 'xs', md: 'sm' });
  const responsiveGridColumns = useBreakpointValue({
    base: '1fr',
    sm: compact ? 'repeat(auto-fill, minmax(200px, 1fr))' : (gridColumns === '1fr' ? '1fr' : 'repeat(auto-fill, minmax(250px, 1fr))'),
    md: compact ? 'repeat(auto-fill, minmax(180px, 1fr))' : gridColumns
  });

  if (!markets || markets.length === 0) {
    return null;
  }

  return (
    <Box mb={3}>
      {title && <Heading size={headingSize} mb={2}>{title}</Heading>}
      <Grid templateColumns={responsiveGridColumns} gap={2}>
        {markets.map((market) => (
          <GridItem
            key={market.id}
            p={2}
            borderWidth="1px"
            borderRadius="lg"
            bg={
              market.marketOutcome === MarketOutcome.VOIDED
                ? 'red.50'
                : market.marketOutcome === MarketOutcome.FINISHED
                ? 'green.50'
                : 'white'
            }
            position="relative"
          >
            <DexchMarketContent
              market={market}
              event={event}
              compact={compact}
            />
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};
